import { useAuthContext } from '../contexts/AuthContext';

export const useAuth = useAuthContext;
